<template>
  <div class="footer">
    <div
      class="img"
      v-lazy:background-image="require('../../assets/images/logo@2x.png')"
    ></div>
    <div class="text">
      <p>电话：+86-571-88162929</p>
      <p>邮箱：contact@ihatoo.com</p>
      <p>地址：浙江省杭州市萧山区宁围街道国泰科技大厦A座1001室</p>
      <p>哈兔中文网络科技有限公司-浙ICP备15040512号</p>
    </div>
    <div
      style="width: 100%; height: 100px"
      v-show="this.$route.name != 'abilityTest'"
    ></div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
};
</script>
<style lang='scss'>
.footer {
  padding: 0 20px;
  background-color: #3c4558;
  color: #abaeb4;
  font-size: 10px;
  overflow: hidden;
  min-height: 159px;
  .img {
    width: 80px;
    height: 25px;
    margin: 20px 0 14.5px;
    // background-image: url("../../assets/images/logo@2x.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  .text {
    p {
      line-height: 21px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer/index.vue